module.exports = __webpack_public_path__ + "img/hotel3_1.c94ce0bb.png";